module.exports = __webpack_public_path__ + "img/icon-jogging.b48ad6fe.png";